import React from 'react';
import PropTypes from 'prop-types';
import { rupiah } from 'utils/formatter';
import styles from './style.css';

class RefundTotal extends React.Component {
  render() {
    const { amount } = this.props;
    return (
      <div>
        <div className={styles['receipt-total-box']}>
          <div className="pull-left">Total</div>
          <div className="pull-right text-pre-wrap">({rupiah(amount)})</div>
        </div>
      </div>
    );
  }
}

RefundTotal.propTypes = {
  amount: PropTypes.number,
};

export default RefundTotal;
